import { Vector } from "./Vector";

export interface IPoint {
    x: number;
    y: number;
}

export class Point implements IPoint {
    constructor(public x: number, public y: number) {
        this.x = x; this.y = y;
    }

    clone() {
        return new Point(this.x, this.y);
    }



    add(point: Point): Point {
        let x = this.x + point.x;
        let y = this.y + point.y;
        return new Point(x, y);// this;
    }

    addVector(vector: Vector): Point {
        let x = this.x + vector.x;
        let y = this.y + vector.y;
        return new Point(x, y);
    }

    subtractVector(vector: Vector): Point {
        let x = this.x - vector.x;
        let y = this.y - vector.y;
        return new Point(x, y);
    }

    subtract(point: Point): Vector {
        let x = this.x - point.x;
        let y = this.y - point.y;
        return new Vector(x, y);
    }

    divide(point: Point): Point {
        let x = this.x / point.x;
        let y = this.y / point.y;
        return new Point(x, y);
    }

    multiply(point: Point): Point {
        let x = this.x * point.x;
        let y = this.y * point.y;
        return new Point(x, y);
    }


    equals(point: Point): boolean {
        let x = point.x === this.x;
        let y = point.y === this.y;

        if (x && y) {
            return true;
        }
        return false;
    }

    static newPoint(p: any) {
        return new Point(p.x, p.y);
    }
    static subtractPoint(p1: Point, p2: Point): Vector {
        let x = p1.x - p2.x;
        let y = p1.y - p2.y;
        return new Vector(x, y);
    }

    static getAngleDegrees(p1: Point, p2: Point, p3: Point) {
        console.log("Point", p1, p2, p3);
        let a = p2.x - p1.x;
        let b = p2.y - p1.y;
        let c = p3.x - p2.x;
        let d = p3.y - p2.y;
        let atanA = Math.atan2(a, b);
        let atanB = Math.atan2(c, d);
        let angle = ((atanA - atanB) * (-180 / Math.PI)) + 180;
        if (angle < 0) angle += 360;
        if (angle > 180) angle -= 360;
        return angle;
    }

    // static getLineAngle(p1: Point, p2: Point):number {
    //     let vector = Point.subtractPoint(p1,p2);
    //     let len = vector.length;
    //     var p3 = new Point(p1.x - (len / 2), p1.y);
    //     return Point.getAngleDegrees(p3, p1, p2);
    // }

    static getLineAngle360(p1: Point, p2: Point): number {
        //var len = (p1 - p2).Length;
        let vector = Point.subtractPoint(p1, p2);
        let len = vector.length;
        let p3 = new Point(p1.x - (len / 2), p1.y);
        let angle = Point.getAngleDegrees(p3, p1, p2);
        if (angle < 0) angle += 360;

        return angle;
    }

    // static getOffsetPoint(start:Point, end:Point,offset:number):Point{
    //     let vector = Point.subtractPoint(end,start);
    //     let v = Vector.distance(vector,offset);
    //     return end.addVector(v);
    // }

    // static getAngle(p1:Point, p2:Point)
    // {
    //     var baseDirection = new Vector(1, 0);
    //     let lineDirection = Point.subtractPoint(p2,p1);
    //     //var lineDirection = (p2 - p1);
    //     lineDirection.normalize();
    //     return 0 - Vector.angleBetween(baseDirection, lineDirection);
    // }

}




